import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/ClearTwoTone';
import SearchIcon from '@material-ui/icons/SearchTwoTone';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Favorite } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/LockTwoTone';
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/PersonOutline';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCartTwoTone';
import { Link as RouterLink, useHistory, useRouteMatch } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import React, { KeyboardEventHandler, useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import DialogConfirm from '../../../@sprinx/react-mui-components/DialogConfirm';
import { catalogueGlobalFilterState } from '../../../api/products/catalogue';
import ShoppingCartAppBarAction from '../../../components/ShoppingCartAppBarAction';
import { isAuthenticatedState, showLoyaltyProgramState } from '../../../api/appState';
import useRouteUrlFactory from '../../../hooks/useRouteUrlFactory';
import { activeFavoriteProducts, projectName } from '../../../config';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import MainNavigationContentItemProfile from './MainNavigationContentItemProfile';
import MainHorisontalNavigation from './MainHorisontalNavigation';
// import LanguageMenu from './LanguageMenu';

export interface AppHeaderProps {
  handleDrawerToggle: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      zIndex: theme.zIndex.drawer + 2,
      backgroundColor: theme.palette.appBar.background,
      color: theme.palette.appBar.color.contrastText,
      minHeight: theme.spacing(9),
      display: 'flex',
      justifyContent: 'center',
    },
    menuButton: {
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    navLinksWrapper: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
        gap: '2rem',
        justifyContent: 'center',
        marginLeft: theme.spacing(4),
        marginRight: 'auto',
      },
    },

    iconsWrapper: {
      marginLeft: 'auto',
      minWidth: 'min-content',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
    },
    icons: {
      color: theme.palette.appBar.color.contrastText,
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 1),
      width: '100%',
      maxWidth: '1400px',
      margin: '0 auto',
    },
    navBottomBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing(1, 1),
    },

    title: {
      fontSize: theme.spacing(1.8),
      color: theme.palette.appBar.color.logo,
      fontWeight: theme.typography.fontWeightBold,
      flexGrow: 1,
      paddingLeft: theme.spacing(3),
      textDecoration: 'none',
      maxWidth: '280px',
      '&:hover': {
        textDecoration: 'none',
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
      },
    },
    mainLogoWrapper: {
      display: 'none',
      maxHeight: '50px',
      textAlign: 'left',
      '@media (min-width: 370px)': {
        display: 'flex',
      },
    },
    startIcon: {
      cursor: 'pointer',
      position: 'absolute',
      left: 0,
      top: theme.spacing(3),
      backgroundColor: 'none',
      fill: theme.palette.appBar.color.contrastText,
      '@media (max-width: 560px)': {
        display: 'none',
      },
    },
    endIcon: {
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(calc(-50% + 2px))',
      backgroundColor: 'inherit',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& svg': {
        fill: '#fafafa',
      },
      '@media (max-width: 560px)': {
        position: 'fixed',
        top: '68px',
        right: '5px',
      },
    },
    search: {
      flexGrow: 5,
      position: 'relative',
      maxWidth: '350px',
      marginLeft: theme.spacing(2),
      marginRight: 'auto',
      [theme.breakpoints.up('md')]: {
        minWidth: theme.spacing(27),
      },
      [theme.breakpoints.up('lg')]: {
        marginRight: theme.spacing(2),
      },
      top: '0px',
      '@media (max-width:560px)': {
        position: 'relative',
      },
    },
    searchMobile: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        backgroundColor: 'inherit',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      },
    },
    additionalNavButton: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    input: {
      color: 'white',
      textAlign: 'center',
      fontSize: '14px',
      padding: '0px!important', // Ensure no default padding interferes with flex centering
      '&:focus': {
        color: 'white',
        '&::placeholder': {
          opacity: 0,
        },
      },
      '&::placeholder': {
        color: theme.palette.appBar.color.contrastText,
        opacity: 1,
        textAlign: 'center',
      },
    },
    ml0: { marginLeft: 0 },
    mainLogo: {
      maxHeight: '50px',
    },
    textField: {
      '& input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration':
        { display: 'none' },
      '& .MuiInputBase-root': {
        borderRadius: '30px',
        backgroundColor: '#454343',
        padding: '2px 10px',
        display: 'flex',
        alignItems: 'center',
        '&:hover:before': {
          borderBottom: 'none!important',
        },
        '&:before': {
          borderBottom: 'none!important',
        },
        '@media (max-width:560px)': {
          marginLeft: theme.spacing(4),
        },
      },
      '& label': {
        color: 'white!important',
        '@media (max-width:560px)': {
          marginLeft: theme.spacing(4),
        },
        '@media (min-width:560px)': {
          paddingLeft: theme.spacing(4),
        },
      },
      '& .MuiInput-underline:after': {
        borderBottom: 'none!important',
      },
      '@media (max-width:560px)': {
        position: 'fixed',
        left: 0,
        top: theme.spacing(8),
        background: 'grey',
        paddingRight: theme.spacing(10),
        paddingBottom: theme.spacing(0.25),
      },
    },
    loyaltyPoints: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      padding: '12px',
      height: '100%',
      '& p': {
        color: theme.palette.appBar.color.contrastText,
        margin: 0,
        padding: 0,
      },
    },
    loyaltyPointsNumber: {
      fontSize: theme.spacing(1.8),
      fontWeight: theme.typography.fontWeightBold,
      flexGrow: 1,
      paddingLeft: theme.spacing(3),
      textDecoration: 'none',
      maxWidth: '280px',
      '&:hover': {
        textDecoration: 'none',
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
      },
    },
  }),
  { name: 'AppHeader' },
);

export default function AppHeader({ handleDrawerToggle }: AppHeaderProps): JSX.Element {
  const history = useHistory();
  const classes = useStyles();
  const routeUrlFactory = useRouteUrlFactory();
  const t = useTranslateWithFallback();
  const [logoutConfirm, setLogoutConfirm] = React.useState<boolean>(false);

  // const autoSubmitRef = React.useRef<NodeJS.Timeout | undefined>(undefined);
  const [initialState, setFilter] = useRecoilState(catalogueGlobalFilterState);
  const [searchFilter, setSearchFilter] = React.useState<string>(initialState.searchText || '');
  const match = useRouteMatch();
  const showFilter = true;
  // match.url.startsWith(routeUrlFactory('catalogue')) || match.url.startsWith(routeUrlFactory('special'));
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const handleClick = React.useCallback(() => setMobileSearchOpen((v) => !v), []);

  const theme = useTheme();
  const isBelowMedium = useMediaQuery(theme.breakpoints.down('md'));
  const isUpMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isAuthenticated = useRecoilValue(isAuthenticatedState);
  const showLoyaltyProgram = useRecoilValue(showLoyaltyProgramState);

  const filterOnChange = (e: any) => {
    const value = e.target.value;
    setSearchFilter(value);
    // TODO: multilang
    // if (value && match.url !== '/catalogue') {
    //   history.push('/catalogue');
    // }
    // if (autoSubmitRef.current) clearTimeout(autoSubmitRef.current);
    // autoSubmitRef.current = setTimeout(() => {
    //   setFilter({ searchText: value });
    // }, 10);
  };

  const handleResetSearchText = useCallback(() => {
    setSearchFilter('');
    setFilter({ searchText: undefined });
  }, [setFilter, setSearchFilter]);

  const handleSearch = useCallback(() => {
    setFilter({ searchText: searchFilter });
    history.push(routeUrlFactory('catalogue'));
  }, [history, routeUrlFactory, searchFilter, setFilter]);

  const handleSearchOnEnter = useCallback<KeyboardEventHandler<HTMLInputElement>>(
    (k) => {
      if (k.key === 'Enter' || k.keyCode === 13 || k.which === 13) {
        handleSearch();
        setMobileSearchOpen(false);
      }
    },
    [handleSearch, setMobileSearchOpen],
  );

  // reset search text real value when coming from another page w/o AppHeader remount
  useEffect(() => {
    setSearchFilter(initialState?.searchText || '');
  }, [setSearchFilter, initialState?.searchText]);

  return (
    <AppBar className={classes.root}>
      <div className={classes.toolbar}>
        <IconButton
          edge='start'
          className={clsx(classes.menuButton, classes.icons)}
          aria-label='open drawer'
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>

        <div className={classes.mainLogoWrapper}>
          <Link component={RouterLink} to={routeUrlFactory('homePage')} noWrap>
            <img src={`/${projectName}/logo_white.svg`} alt={`${projectName} logo`} className={classes.mainLogo} />
          </Link>
        </div>
        {/* Původní podmínka níže, nutno upravit dle designového zadání */}
        {/* {!isMobile && mobileSearchOpen && (  */}
        {/* <NavigationLinks className={classes.navLinksWrapper} /> */}
        <MainHorisontalNavigation />

        {(!isBelowMedium || mobileSearchOpen) && showFilter && (
          <div className={classes.search}>
            <TextField
              margin='dense'
              fullWidth
              placeholder={t('app/globalSearchPlaceholder')}
              value={searchFilter}
              className={classes.textField}
              onChange={filterOnChange}
              onKeyUp={handleSearchOnEnter}
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <SearchIcon
                    color='secondary'
                    fontSize='default'
                    onClick={handleSearch}
                    style={{ cursor: 'pointer', color: 'white' }}
                  />
                ),
                classes: { input: classes.input },
              }}
              inputProps={{
                type: 'search',
                enterkeyhint: 'done',
              }}
            />

            {searchFilter.length > 0 && (
              <IconButton onClick={handleResetSearchText} className={classes.endIcon}>
                <ClearIcon fontSize='small' />
              </IconButton>
            )}
          </div>
        )}
        <div className={clsx(classes.iconsWrapper)}>
          {isBelowMedium && showFilter && (
            <SearchMobile
              mobileSearchOpen={mobileSearchOpen}
              onClick={handleClick}
              className={clsx(classes.searchMobile, classes.icons)}
            />
          )}

          {activeFavoriteProducts && isAuthenticated && (
            <Tooltip title={t('favoriteProductsPage/title')} className={classes.additionalNavButton}>
              <IconButton component={RouterLink} to={routeUrlFactory('favoriteProducts')} className={classes.icons}>
                <Favorite />
              </IconButton>
            </Tooltip>
          )}
          {isAuthenticated && (
            <Tooltip title={t('mainNavigation/bulkPurchase')} className={classes.additionalNavButton}>
              <IconButton component={RouterLink} to={routeUrlFactory('bulkPurchase')} className={classes.icons}>
                <AddShoppingCartIcon />
              </IconButton>
            </Tooltip>
          )}
          {isAuthenticated && <ShoppingCartAppBarAction className={classes.icons} />}
          {/* <LanguageMenu /> */}
          {isAuthenticated ? (
            <>
              {isUpMedium && showLoyaltyProgram && (
                <Link component={RouterLink} to={routeUrlFactory('loyaltyProgram')} noWrap>
                  <div className={classes.loyaltyPoints}>
                    <p>MY.PARTNER</p>
                  </div>
                </Link>
              )}
              <MainNavigationContentItemProfile className={classes.icons} />
            </>
          ) : (
            <Tooltip title={t('loginPage/twoWordsLogin')}>
              <IconButton
                component={RouterLink}
                to={`${routeUrlFactory('login')}?from=${encodeURIComponent(match.url)}`}
                className={classes.icons}
              >
                <PersonIcon />
              </IconButton>
            </Tooltip>
          )}
          {isAuthenticated && (
            <Tooltip title={t('app/logout')}>
              <IconButton
                edge='end'
                className={classes.icons}
                onClick={() => {
                  setLogoutConfirm(true);
                }}
              >
                <LockIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
        <DialogConfirm
          open={logoutConfirm}
          onClose={() => {
            setLogoutConfirm(false);
          }}
          onConfirm={() => {
            history.push(routeUrlFactory('logout'));
          }}
          title={t('app/logout')}
        >
          <div>{t('app/logoutConfirmation')}</div>
        </DialogConfirm>
      </div>
    </AppBar>
  );
}

const SearchMobile: React.FC<{ className?: string; mobileSearchOpen: boolean; onClick: () => void }> = ({
  className,
  onClick,
  mobileSearchOpen,
}) => {
  const t = useTranslateWithFallback();
  return (
    <button className={className} onClick={onClick}>
      {!mobileSearchOpen ? (
        <Tooltip title={t('app/globalSearchPlaceholder')}>
          <SearchIcon />
        </Tooltip>
      ) : (
        <Tooltip title={t('app/hideGlobalSearchPlaceholder')}>
          <ClearIcon />
        </Tooltip>
      )}
    </button>
  );
};
